import { render, staticRenderFns } from "./DreieckRW.vue?vue&type=template&id=e244b314&"
import script from "./DreieckRW.vue?vue&type=script&lang=js&"
export * from "./DreieckRW.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports